<template lang="pug">
  div
    p These are the values used to make a request for rates.
    form#quote.vertical.wide
      // User info other than address
      fieldset
        label Email Address
          input(type="text" v-model="settings.user.emailAddress")
        label First Name
          input(type="text" v-model="settings.user.firstName")
        label Last Name
          input(type="text" v-model="settings.user.lastName")
        label Phone Number
          input(type="text" v-model="settings.user.phoneNumber")
      // User address info
      fieldset
        label Street
          input(type="text" v-model="settings.user.address.street")
        label City
          input(type="text" v-model="settings.user.address.city")
        label State
          input(type="text" v-model="settings.user.address.state")
        label Zip (5 digit)
          input(type="text" v-model="settings.user.address.zip")
      // Car other than flags
      fieldset
        label VIN
          input(type="text" v-model="settings.car.vin")
        label Miles Driven Per Year
          input(type="text" v-model="settings.car.milesPerYear")
        label Odometer
          input(type="text" v-model="settings.car.odometer")
        label Years to Own
          input(type="text" v-model="settings.car.yearsToOwn")
      fieldset
        label Commercial Use?
          input(type="checkbox" v-model="settings.car.flags.commercialUse")
        label Certified Preowned?
          input(type="checkbox" v-model="settings.car.flags.certifiedPreowned")
        label Second Owner?
          input(type="checkbox" v-model="settings.car.flags.secondOwner")
        label Lift Kit or Oversized Tires?
          input(type="checkbox" v-model="settings.car.flags.hasLiftKitOrOversizeTires")
        label Modified?
          input(type="checkbox" v-model="settings.car.flags.modifiedVehicle")
        label Salvage Title?
          input(type="checkbox" v-model="settings.car.flags.isSalvageTitle")
    action-button(@click="save" title="Save" :disabled="false" :loading="loading")
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ActionButton from '@/components/ActionButton'
  export default {
    name: 'Loan',
    components: {
      ActionButton
    },
    data () {
      return {
        loading: false,
        settings: {
          user: {
            address: {}
          },
          car: {}
        }
      }
    },
    methods: {
      ...mapActions(['setQuoteRequest']),
      async save () {
        this.loading = true
        console.log(this.settings)
        try {
          await this.setQuoteRequest(this.settings)
        } catch (err) {
          console.error(err)
        }
        this.loading = false
      }
    },
    computed: {
      ...mapGetters(['quoteRequest'])
    },
    created () {
      this.settings = this.quoteRequest
    }
  }
</script>

<style lang="sass">
  #quote
    display: flex
    flex-direction: column
    justify-content: flex-start
    align-items: center
    margin: 0 auto
</style>
